if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(max-width: 750px)');

        if (!this.elements.viewer) return;

        // ✅ DOTS
        this.dotsContainer = this.querySelector('.media-gallery-dots');

        // ✅ VARIANT MEDIA MAP
        this.variantMediaMap = JSON.parse(
          document.getElementById('VariantMedia')?.textContent || '{}'
        );

        // SLIDE CHANGE
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 300)
        );

        // THUMBNAIL CLICK
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
              );
          });
        }

        // INIT DOTS (mobile) 
        // console.log(this.dotsContainer);
        if (this.dotsContainer && this.mql.matches) {
          this.initDots();
        }

        // LISTEN VARIANT CHANGE
        document.addEventListener('variant:change', (event) => {
          this.filterVariantImages(event.detail.variant);
        });

        // FALLBACK (if event not available)
        document.addEventListener('change', (e) => {
          if (e.target.name === 'id') {
            try {
              const variant = JSON.parse(e.target.selectedOptions[0].dataset.variant);
              document.dispatchEvent(
                new CustomEvent('variant:change', { detail: { variant } })
              );
            } catch (err) {}
          }
        });
      }

      // =============================
      // ✅ DOTS
      // =============================
      initDots() {
        const slides = this.getVisibleSlides();
        this.dotsContainer.innerHTML = '';

        slides.forEach((slide, index) => {
          // console.log(slide.dataset.alt); // debug
          const dot = document.createElement('button');
          dot.classList.add('media-dot');
          dot.dataset.alt = slide.dataset.alt;
          dot.dataset.index = index;
          dot.addEventListener('click', (e) => {
            const i = parseInt(e.currentTarget.dataset.index, 10);
            this.goToSlide(i);
          });
          this.dotsContainer.appendChild(dot);
        });
        this.updateDots(0);
      }

      

      goToSlide(index) {
        const slides = this.getVisibleSlides();
        const target = slides[index];
        if (!target) return;

        this.setActiveMedia(target.dataset.mediaId, false);
        this.updateDots(index);
      }

      updateDots(index) {
        if (!this.dotsContainer) return;

        this.dotsContainer.querySelectorAll('.media-dot').forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      }

      getVisibleSlides() {
        return Array.from(
          this.elements.viewer.querySelectorAll('[data-media-id]')
        ).filter((el) => {
          return (
            !el.classList.contains('splide__slide--clone') &&
            !el.closest('.splide__slide--clone') &&
            !el.classList.contains('hidden')
          );
        });
      }

      // =============================
      // ✅ VARIANT FILTER
      // =============================
      filterVariantImages(variant) {
        if (!variant || !this.variantMediaMap) return;

        const mediaId = this.variantMediaMap[variant.id];

        const allMedia = this.elements.viewer.querySelectorAll('[data-media-id]');
        const allThumbs = this.elements.thumbnails
          ? this.elements.thumbnails.querySelectorAll('[data-target]')
          : [];

        let hasVariantMedia = false;

        allMedia.forEach((item) => {
          if (item.dataset.mediaId == mediaId) {
            hasVariantMedia = true;
          }
        });

        // SHOW / HIDE MEDIA
        allMedia.forEach((item) => {
          if (hasVariantMedia) {
            item.classList.toggle('hidden', item.dataset.mediaId != mediaId);
          } else {
            item.classList.remove('hidden');
          }
        });

        // THUMBNAILS
        allThumbs.forEach((thumb) => {
          if (hasVariantMedia) {
            thumb.classList.toggle('hidden', thumb.dataset.target != mediaId);
          } else {
            thumb.classList.remove('hidden');
          }
        });

        // SET ACTIVE
        if (hasVariantMedia) {
          this.setActiveMedia(mediaId, true);
        }

        // RESET SLIDER
        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }

        // REBUILD DOTS
        if (this.dotsContainer && !this.mql.matches) {
          this.initDots();
        }
      }

      // =============================
      // EXISTING METHODS
      // =============================

      onSlideChanged(event) {
        const currentId = event.detail.currentElement.dataset.mediaId;

        const slides = this.getVisibleSlides();
        const index = slides.findIndex(
          (slide) => slide.dataset.mediaId === currentId
        );

        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${currentId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        this.updateDots(index);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement.firstChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia);
        }

        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
    }
  );
}